import { render, staticRenderFns } from "./WithdrawalHistory.vue?vue&type=template&id=1b403a0e&scoped=true&"
import script from "./WithdrawalHistory.vue?vue&type=script&lang=js&"
export * from "./WithdrawalHistory.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawalHistory.vue?vue&type=style&index=0&id=1b403a0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b403a0e",
  null
  
)

export default component.exports